import { render, staticRenderFns } from "./Reservations.vue?vue&type=template&id=19d37ca1&scoped=true"
import script from "./Reservations.vue?vue&type=script&lang=js"
export * from "./Reservations.vue?vue&type=script&lang=js"
import style0 from "./Reservations.vue?vue&type=style&index=0&id=19d37ca1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d37ca1",
  null
  
)

export default component.exports